<template>
  <div class="transfer">
    <div class="content">
      <vxe-table
        class='atb-table header-table edit-table'
        border='full'
        height='100%'
        auto-resize
        resizable
        :data="workItem"
      >
      <vxe-table-column field="workItemCategory" title="类别" width="100"></vxe-table-column>
      <vxe-table-column field="workItemContent" width="100" title="工作项目"></vxe-table-column>
      <vxe-table-column field="finishDate" width="125" title="总目标完成时间">
        <template #default="{ row }">{{ formatDate(row.finishDate, 'yyyy-MM-dd') }}</template>
      </vxe-table-column>
      <vxe-table-column v-if="type === 'month' || type === 'week'" field="wholeTarget" title="总目标"></vxe-table-column>
      <vxe-table-column v-if="type === 'month'" field="currentMonthTarget" width="140" title="本月需达到的目标"></vxe-table-column>
      <vxe-table-column v-if="type === 'month'" field="currentMonthFinishDate" width="140" title="本月目标完成时间">
        <template #default="{ row }">{{ formatDate(row.currentMonthFinishDate, 'yyyy-MM-dd') }}</template>
      </vxe-table-column>
      <vxe-table-column v-if="type === 'week'" field="currentWeekTarget" width="140" title="本周需达到的目标"></vxe-table-column>
      <vxe-table-column v-if="type === 'week'" field="currentWeekFinishDate" width="140" title="本周目标完成时间">
        <template #default="{ row }">{{ formatDate(row.currentWeekFinishDate, 'yyyy-MM-dd') }}</template>
      </vxe-table-column>
      <vxe-table-column field="weight" v-if="type === 'year'" title="权重" width="60"></vxe-table-column>
      <vxe-table-column v-if="type === 'year'" field="fullTarget" title="总目标"></vxe-table-column>
      <vxe-table-column field="sendName" title="发起人"></vxe-table-column>
      <vxe-table-column field="DesigneeName" title="指定人"></vxe-table-column>
    </vxe-table>
    </div>
    <div class="form-wrap" v-if="hideApprove">
      <el-form :model="editForm" hide-required-asterisk :rules="rules" ref="form" label-width='92px' class="atb-input" label-position="right">
        <el-form-item label="审批意见" prop="approveReason" label-width="80px">
          <el-input :readonly="!role" type="textarea" maxlength="500" v-model="editForm.approveReason"></el-input>
          <fast-approve v-if="role" @approveText="approveText"></fast-approve>
        </el-form-item>
      </el-form>

    </div>
    <div class="btn-wrap">
      <el-button v-if="role" type="passed" class="btn" @click="approve(40)">通过</el-button>
      <el-button v-if="role" type="rejected" class="btn" @click="approve(50)">驳回</el-button>
      <el-button type="clear" class="btn" @click="$parent.$parent.hide()">关闭</el-button>
    </div>
  </div>
</template>

<script>
import XEUtils from "xe-utils";


export default {
  name: "transfer",
  data() {
    return {
      workItem: [],
      type: '',
      userInfo: {},
      editForm: {
        approveReason:''
      },
      rules: {
        approveReason: [
          { required: true, message: '请填写审批意见', trigger: 'blur' }
        ],
      }
    }
  },
  props: {
    msg: {
      default: new Object(),
      type: Object
    },
    role: {
      default: 0,
      type: Number
    },
    hideApprove: {
      type: Boolean,
      default: true
    }
  },
  mounted() {
    this.getDetail();
  },
  methods: {
    approveText(e) {
      this.editForm.approveReason = e;
    },
    filterWorkType(type) {
      if (type.indexOf("Year") !== -1) {
        this.type = "year";
        return this.$api.year.yearWorkDetail.list;
      } else if (type.indexOf("Month") !== -1) {
        this.type = "month";
        return this.$api.month.MonthWorkDetail.list;
      } else {
        this.type = "week";
        return this.$api.week.WeekWorkDetail.list;
      }
    },
    filterAction(type) {
      if (type == "YearPlanTransfer") {
        return this.$api.transfer.yearTransfer;
      } else if (type == "MonthWorkTransfer") {
        return this.$api.transfer.monthTransfer;
      } else if (type == "WeekWorkTransfer") {
        return this.$api.transfer.weekTransfer;
      } else if (type == "YearPlanHandover") {
        return this.$api.transfer.yearHandover;
      } else if (type == "MonthWorkHandover") {
        return this.$api.transfer.monthHandover;
      } else {
        return this.$api.transfer.weekHandover;
      }
    },
    formatDate(value, format) {
      return XEUtils.toDateString(value, format)
    },
    getDetail() {
      this.userInfo = JSON.parse(this.msg.extend);
      this.$ajax.get(this.filterWorkType(this.msg.sendAction), {
        workId: this.msg.msgObjectId,
        WorkItemIds: this.msg.msgObjectChildId.join(","),
      }).then(res => {
        const result = res.data.detailDtoList || res.data.details;
        this.editForm.approveReason=this.role? '': result[0].approveReason;
        this.workItem = result.map(val => {
          return {...val, DesigneeName: this.userInfo.DesigneeName, sendName: this.userInfo.SenderName}
        });
      });
    },
    approve(action) {
      if(action === 50) {
        if(typeof(this.editForm.approveReason)==="undefined" || this.editForm.approveReason===null || this.editForm.approveReason.split(" ").join("").length === 0 || this.editForm.approveReason.replace(/\s+/g,"").length===0){
          return  this.$message.error("必须填写驳回原因");
        }
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.$ajax.put(this.filterAction(this.msg.sendAction), [{
              workId: this.msg.msgObjectId,
              id: this.msg.msgObjectChildId[0],
              status: action,
              DesigneeNo: this.userInfo.DesigneeNo,
              approveReason: this.editForm.approveReason,
              MsgId: this.msg.id
            }]).then(() => {
              this.$message.success("审批成功");
              this.$emit('submitSuccess');
              this.$parent.$parent.hide();
            });
          } else {
            return false;
          }
        });
      }else {
        this.$refs.form.clearValidate();
        this.$ajax.put(this.filterAction(this.msg.sendAction), [{
          workId: this.msg.msgObjectId,
          id: this.msg.msgObjectChildId[0],
          status: action,
          DesigneeNo: this.userInfo.DesigneeNo,
          approveReason: this.editForm.approveReason,
          MsgId: this.msg.id
        }]).then(() => {
          this.$message.success("审批成功");
          this.$emit('submitSuccess');
          this.$parent.$parent.hide();
        });
      }

    }
  }
}
</script>

<style scoped lang='scss'>
.transfer {
  .el-button.el-button--passed {
    color: #ffffff;
    background-color: #22b6a1;
    border-color: #22b6a1;
  }
  .el-button.el-button--rejected {
    background-color: #0dcc82;
    border-color: #0dcc82;
    color: #ffffff;
  }
  .el-button.el-button--clear {
    background-color: #F5BF2B;
    border-color: #F5BF2B;
    color: #ffffff;
  }
  .el-button {
    width: 110px;
    border-radius: 10px;
  }
  .content {
    height: 350px;
  }
  .btn-wrap {
    margin-top: 10px;
    text-align: right;
  }
  .form-wrap{
    margin: 10px 0px;
  }
  .atb-input {
    .el-form-item{
      margin-right: 0px;
    }
  }
}
</style>